import React from 'react'
import { Stack } from '@mantine/core'
import ReportWrapper from '../ReportWrapper'
import PageEmpty from '../../../components/PageEmpty'
import CompanySummary from './CompanySummary'
import CompanyList from './CompanyList'
import { CdDataRelationCompanyData, CompanyItem } from './types'
import ReportSectionHeading from '../ReportSectionHeading'

interface RongdataRelationCompanyInformationProps {
  data: any
  title: string
  sectionIndex?: string
}

const RongdataRelationCompanyInformation: React.FC<RongdataRelationCompanyInformationProps> = ({
  data,
  title,
  sectionIndex,
}) => {
  const jsonData: CdDataRelationCompanyData = JSON.parse(data.cddata_relation_companies ?? '{}')
  const companies: CompanyItem[] = jsonData?.queryResult?.items || []

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <Stack gap="md">
        {companies.length === 0 ? <PageEmpty /> : <CompanySummary companies={companies} />}
        {companies.length > 0 && <CompanyList companies={companies} />}
      </Stack>
    </ReportWrapper>
  )
}

export default RongdataRelationCompanyInformation
